import { render, staticRenderFns } from "./PartnerMaster.vue?vue&type=template&id=0f82230d"
import script from "./PartnerMaster.vue?vue&type=script&lang=js"
export * from "./PartnerMaster.vue?vue&type=script&lang=js"
import style0 from "./PartnerMaster.vue?vue&type=style&index=0&id=0f82230d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports